import { deserify } from '@geneo2-web/shared-ui';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import {
  getProjectClassSections,
  isProjectAllowedSubjectCode,
} from '../../pages/Laboratory/projectSubjects.utils';
import { useAppSelector } from '../../reduxStore/reduxHooks';
import { HOME } from '../RoutesNomenclature';

// The Create Project entry points are only shown for a subject projects can be
// created for - this also stops a deep link or bookmark opening the creation
// screen for any other subject.
const CreateProjectRouteGuard = () => {
  const { subject_id } = useParams();
  const user_info = deserify(useAppSelector((state) => state.auth.user_info));

  const isAllowedSubject = getProjectClassSections(user_info).some(
    (classSection) =>
      classSection.subjects.some(
        (subject) =>
          String(subject.subjectId) === subject_id &&
          isProjectAllowedSubjectCode(subject.subjectEnum)
      )
  );

  return isAllowedSubject ? <Outlet /> : <Navigate to={HOME} replace />;
};

export default CreateProjectRouteGuard;
